export default __webpack_public_path__ + "static/media/logo_main-white.6a43fd0f.svg";